import { useIsSingleRecordQuery } from '@modules/quantify/hooks/useIsSingleRecordQuery';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';

interface UseIsCooccurrenceIconVisibleOptions {
  isTableView: boolean;
}

export const useIsCooccurrenceIconVisible = ({
  isTableView,
}: UseIsCooccurrenceIconVisibleOptions): boolean => {
  const dataPoints = useQuantifyStore(({ reportData, query }) => {
    if (isTableView) {
      return query.compareQuery
        ? reportData.compare.tableRows
        : reportData.quantify.tableRows;
    }

    return query.compareQuery
      ? reportData.compare.chartDataPoints
      : reportData.quantify.chartDataPoints;
  });

  const isSingleRecordQuery = useIsSingleRecordQuery();

  if (isSingleRecordQuery) {
    return false;
  }

  return dataPoints?.some((dataPoint) => !dataPoint.isRelevant) ?? false;
};
